<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            ref="grid"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
            navigationPath="SpecialNeedsStudentView"
            navigationField="studentID"
        ></dx-grid>
    </div>
</template>

<script>
export default {
    data: () => ({
        title: "Students",

        actions: [],
        userBranch: "",
        url: "",
        regID: "",

        columns: [
            {
                label: "Provider",
                field: "provider",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name",
                field: "lastName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Name",
                field: "engName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name H",
                field: "lastNameH",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Name H",
                field: "hebName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student ID",
                field: "studentID",
                link: "StudentView",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "familyID",
                label: "Account ID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date Entered",
                field: "dateEntered",
                visible: true,
                filterValues: [],
                filterValue: null,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                selectedFilterOperation: null,
            },
            {
                label: "Last Progress Report",
                field: "lastProgressReport",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Building",
                field: "building",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Grade",
                field: "class",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Section",
                field: "section",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher",
                field: "teacherDescription",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Work Status",
                field: "workStatus",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: "Active",
                selectedFilterOperation: "=",
            },
            {
                label: "Home Phone",
                field: "homePhone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address1",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Referral",
                field: "referral",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status Reason",
                field: "statusReason",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Process",
                field: "process",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Note",
                field: "note",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Evaluated By",
                field: "evaluatedBy",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Evaluation Outcome",
                field: "evaluationOutcome",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Updated By",
                field: "updatedBy",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Updated At",
                field: "updatedAt",
                visible: false,
                filterValues: [],
                filterValue: null,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                selectedFilterOperation: null,
            },
            {
                field: "followUpDate",
                label: "Follow Up Date",
                format: "",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy",
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "followUpNote",
                label: "Follow Up Note",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Reg ID",
                field: "regID",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    async created() {
        this.columns.find(
            (c) => c.field == "familyID",
        ).showLink = this.showLink;
    },
    beforeDestroy() {},
    methods: {
        async beforeSetupGrid() {
            this.userBranch = this.$store.state.authentication.branch;

            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms.sort(),
                value: this.regID,
                onSelected: this.onTermSelected,
            });

            this.url =
                "specialNeedsProgram?regID=" +
                this.regID +
                (this.userBranch != "null"
                    ? "&branch=" + this.userBranch
                    : "&branch=") +
                (this.isProvider()
                    ? "&provider=" + this.$store.state.authentication.user
                    : "&provider=");
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/allStudents/getRegID");
        },
        async getTerms() {
            return await this.$http.get("api/allStudents/getRegTerms");
        },
        onTermSelected(value) {
            this.regID = value;

            this.url =
                "specialNeedsProgram?regID=" +
                this.regID +
                (this.userBranch != "null"
                    ? "&branch=" + this.userBranch
                    : "&branch=") +
                (this.isProvider()
                    ? "&provider=" + this.$store.state.authentication.user
                    : "&provider=");

            this.$refs.grid.reloadDataSource(this.url);
        },
        showLink() {
            return (
                !this.isProvider() &&
                (!this.$store.state.authentication.branch ||
                    this.$store.state.authentication.branch == "null")
            );
        },
        isProvider() {
            const roles = Array.isArray(this.$store.state.authentication.roles)
                ? this.$store.state.authentication.roles
                : this.$store.state.authentication.roles
                ? this.$store.state.authentication.roles.split(",")
                : [];

            return roles.includes("Special Needs Provider");
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
</style>
